import {
  markingCourseCompleted,
  markCourseCompletedSuccess,
  markCourseCompletedError,
} from './actions'
import { Options } from './types'
import { clearErrors } from '../'
import { completeTrainingCourse } from '../../api/dx-training'

export const markTrainingCourseComplete = (options: Options) => {
  return async dispatch => {
    try {
      dispatch(clearErrors())
      dispatch(markingCourseCompleted())
      await completeTrainingCourse(options)
      dispatch(markCourseCompletedSuccess())
    } catch (error) {
      dispatch(markCourseCompletedError(error.message))
    }
  }
}
